export const participantTypes = {
  GET: 'participant/GET',
  SAVE: 'participant/SAVE',
  UPDATE: 'participant/UPDATE_SINGLE',
  GET_RESPONSE: 'participant/GET_RESPONSE',
  MANAGE: 'participant/MANAGE',
  CHANGE_STATUS: 'participant/CHANGE_STATUS',
  CHANGE_STATUS_RES: 'participant/CHANGE_STATUS_RESPONSE',
  CHANGE_COMMENT: 'participant/CHANGE_COMMENT',
  CHANGE_COMMENT_RES: 'participant/CHANGE_COMMENT_RESPONSE',
  REMOVE: 'participant/REMOVE_FROM_LOADED',
  CHANGE_LOCATION: 'participant/CHANGE_LOCATION',
  CHANGE_LOCATION_RES: 'participant/CHANGE_LOCATION_RESPONSE'
}

export const getParticipant = (id) => (
  {
    type: participantTypes.GET,
    id
  }
)

export const playerManage = (data) => (
  {
    type: participantTypes.MANAGE,
    data
  }
)

export const changePlayerStatus = (data) => (
  {
    type: participantTypes.CHANGE_STATUS,
    data
  }
)

export const removePlayerFromLoaded = (id) => (
  {
    type: participantTypes.REMOVE,
    id
  }
)

export const changePlayerComment = (data) => (
  {
    type: participantTypes.CHANGE_COMMENT,
    data
  }
)

export const changePlayerLocation = (city) => (
  {
    type: participantTypes.CHANGE_LOCATION,
    city
  }
)



// WEBPACK FOOTER //
// ./src/actions/participant.js